<div class="add-lookup-container">
    <div class="lookup-header">
        <p class="add-lookup-title">{{lookupName}} 
            <img matTooltip="Asset Type refers to a specific category or model of an asset. It helps you group and identify similar assets easily. (e.g. Enviro 400 double-decker for a bus)" 
                src="assets/icons/information-outline.svg" [matTooltipPosition]="'above'">
        </p>
        <a (click)="closeForm()">
            <i class="fas fa-lg fa-times lookup-close"></i>
        </a>
    </div>
    <div class="new-lookup-input">
        <mat-form-field class="custom-form-field" subscriptSizing="dynamic">
            <mat-label>New {{lookupName}}</mat-label>
            <input matInput type="text" [(ngModel)]="newValue">
        </mat-form-field>
        <button mat-flat-button color="accent" (click)="addNew()" >
            Add
        </button>   
    </div>
    <p class="lookup-list-title">{{listTitle}} <span class="lookup-results-count">[{{resultsLength}}]</span></p>
    <mat-form-field *ngIf="showSearchBar" class="custom-form-field" subscriptSizing="dynamic">
        <mat-label>Search</mat-label>
        <input matInput (keydown.enter)="$event.preventDefault()" (keyup)="searchTermChanged($event)"/>
        <i matPrefix class="fas mr-2 fa-search"></i>
    </mat-form-field>
    <mat-list class="lookup-list">
        <div *ngFor="let lookup of data;" class="lookup-item" (click)="selectItem(lookup)">
            <mat-list-item [value]="lookup.id">{{lookup.name}}
            </mat-list-item>
            <button mat-icon-button (click)="delete($event, lookup)">
                <i class="fas fa-lg fa-times"></i>
            </button>
        </div>
    </mat-list>
</div>